import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../App.css'


function ProjectInformation(props){

    const modules = {
        toolbar: [
            [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': ['black','#80002A', '#440119', '#FFB3CA', '#0fba9c', '#C6FAF1', 
                                 '#091EB7', '#C2C9FC', '#BFBFBF', '#7F7F7F', '#E4E4E4'] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
        ],
        clipboard: {
            matchVisual: false
        }
    };

    // const modules_none = {
    //     toolbar: null,
    // };


    return(<>
            <input id='title' style = {{'marginTop': '20px', 'marginBottom': '0px', 'border':'none', 'outline':'none', 'padding':'5px', 'borderLeft':'0.5px solid var(--aixelo-gray-light)', 'fontSize': '24px', 'fontWeight':'bold', position: 'relative', left:'3%', width:'94%'}} 
                onChange = {props.handleTitle} value={props.projectInfo.title} autoComplete="false" type="text" placeholder="Enter Project Title"  name="project_title" />
            <h4 style = {{'margin':'0', 'marginBottom':'10px', marginTop:'25px', 'padding':'0px', position: 'relative', left:'3%', width:'94%'}} >Project Description</h4>
            <div style = {{position: 'relative', left:'3%', width:'94%'}}>
                <ReactQuill modules={modules} theme="snow" value={props.projectInfo.description} onChange={props.handleDescription} />
            </div>
    </>);
}


export default ProjectInformation
